module.exports = __webpack_public_path__ + "blueprint-purple-no-labels-selector.e32e264ba70958469448.png";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/blueprint-purple-no-labels-selector.png
// module id = ../../../../../src/assets/img/blueprint-purple-no-labels-selector.png
// module chunks = main